import React from 'react';
import styled from 'styled-components';

import useModal from '@/hooks/useModal';
import LabelUsingAffixIcon from '@/components/ContextPrinter/LabelUsingAffixIcon';
import SvgSelector from '@/components/Svg/SvgSelector';
import InAAsk from '@/containers/modal/InA/InAAsk';

interface IProps {
    questionId: number;
    content: string;
    category: number[];
    title: string;
    fileNames: string[];
    fileURLs: string[];
}

const ReviseModal = ({ questionId, content, category, title, fileNames, fileURLs }: IProps) => {
    const { addModal, removeCurrentModal } = useModal();

    return (
        <Container
            onClick={() => {
                removeCurrentModal();

                addModal({
                    key: 'fullScreen',
                    props: {
                        isCloseIconOnRight: false,
                        content: (
                            <InAAsk
                                title={title}
                                questionId={questionId}
                                content={content}
                                category={category}
                                fileNames={fileNames}
                                fileURLs={fileURLs}
                            />
                        ),
                        handleCloseModal: removeCurrentModal,
                    },
                });
            }}
        >
            <LabelUsingAffixIcon
                prefixUri={<SvgSelector svg="writing" width={22} height={22} fill="#ffffff" stroke="#888888" />}
                label="수정하기"
            />
        </Container>
    );
};

const Container = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    align-items: center;
    padding: 23px 0 23px 20px;
`;

export default ReviseModal;
